import { render, staticRenderFns } from "./DisplayAds.vue?vue&type=template&id=5547c90e"
import script from "./DisplayAds.vue?vue&type=script&lang=js"
export * from "./DisplayAds.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports